import 'css-chunk:src/applications/ProductFulfillmentApp/CreatorProductSelection/components/OrderRequestReview/components/Products/Products.module.scss';export default {
  "productList": "_productList_mx2vl_1"
};